// extracted by mini-css-extract-plugin
module.exports = {"filterToggle":"Dashboard_filter-toggle__U635h","filterWrapper":"Dashboard_filter-wrapper__1dIaM","open":"Dashboard_open__1i_TL"};